





































import { PaymentLogo } from '@superbet-group/web.lib.config';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import { SdsLink } from '@superbet-group/web.lib.ui-components';
import { getWikiPath } from '@modules/wiki/navigateToWiki';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';

import countryStoreIndex from '@store/modules/data/country/countryIndex';

import FooterColumnsTitle from './FooterColumnsTitle.vue';

export default defineComponent({
    setup() {
        const countryStore = useVuexStore<typeof countryStoreIndex>('data/country');
        const paymentProvidersLogos = countryStore.getter('paymentProvidersLogos');

        function getComponentType(payment: PaymentLogo) {
            if (!payment.path) {
                return 'div';
            }
            return SdsLink;
        }

        function getTo(payment: PaymentLogo) {
            switch (payment.linkType) {
                case 'External':
                    if (!payment.path!.startsWith('http')) {
                        return `${window.location.protocol}//${window.location.host}${payment.path}`;
                    } else {
                        return payment.path;
                    }
                case 'Static':
                    return getWikiPath(payment.path);
            }
        }

        return {
            payments: computed(() => paymentProvidersLogos.value?.footer),

            getComponentType,
            getTo,
        };
    },
    components: {
        FooterColumnsTitle,
        SdsLink,
    },
});
